export const SHOW_UNITS = "showUnits";
export const SHOW_DOORS = "showDoors";
export const SHOW_TOTAL_COST = "showTotalCost";
export const SHOW_TOTAL_RETAIL = "showTotalRetail";
export const DEFAULT_VIEW_SETTINGS = "defaultTileSettings";
export const CUSTOM_VIEW_SETTINGS = "customTileSettings";
